import { getApiBaseUrl, instance } from "@/lib/clients"

function getDownloadFilename(
  contentDisposition: unknown,
  fallbackFilename: string,
): string {
  if (typeof contentDisposition !== "string") {
    return fallbackFilename
  }

  const encodedFilename = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (encodedFilename?.[1]) {
    try {
      return decodeURIComponent(encodedFilename[1])
    } catch {
      return fallbackFilename
    }
  }

  const filename = contentDisposition.match(/filename="([^"]+)"/i)
  return filename?.[1] ?? fallbackFilename
}

export async function downloadFile(
  url: string,
  fallbackFilename: string,
): Promise<void> {
  const response = await instance.get<Blob>(url, {
    baseURL: getApiBaseUrl(),
    responseType: "blob",
    withCredentials: true,
  })
  const objectUrl = URL.createObjectURL(response.data)
  const link = document.createElement("a")

  link.href = objectUrl
  link.download = getDownloadFilename(
    response.headers["content-disposition"],
    fallbackFilename,
  )
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
}
